<template>
  <div :class="forSidebar ? 'sidebar-logo' : ''">
    <template v-if="itemOrganization.attributes.preferences.logo">
      <a :href="customLogoHref" @click="trackLogoClicked" class="navbar-brand small-logo" data-testid="custom-logo-link">
        <img :src="itemOrganization.attributes.preferences.logo" class="logo navbar-brand small-logo" data-testid="custom-logo">
      </a>
    </template>
    <template v-else>
      <div class="logo-container">
        <a :href="logoLinkUrl" @click="trackLogoClicked" class="navbar-brand small-logo" data-testid="logo-link-back-to-dashboard" :target="gon.currentUser ? '_self' : '_blank'">
          <img :src="LogoImage" class="logo">
        </a>
        <a v-if="showCloudappLink" :href="logoLinkUrl" class="navbar-brand small-logo" data-testid="logo-link-back-to-dashboard" :target="gon.currentUser ? '_self' : '_blank'">
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import track from '@/src/tracking';
import LogoImage from "../../images/logo@2x.png";

export default {
  props: {
    showCloudappLink: Boolean,
    forSidebar: Boolean
  },
  data: function() {
     return {
      LogoImage,
      itemOrganization: this.$root.itemOrganization
    }
  },
  methods: {
    trackLogoClicked: function() {
      const vm = this;
      track('app_logo_click', { hashid: vm.$root.item.id, viewer: "dropper" });
    }
  },
  computed: {
    logoLinkUrl: function() {
      return gon.currentUser ? this.$root.routes.dashboard_url() : "https://www.getcloudapp.com/screen-recorder?utm_source=viewer&utm_campaign=viewer_header_link";
    },
    dashboardUrl: function() {
      return this.$root.routes.dashboard_url();
    },
    customLogoHref: function() {
      if (gon.currentUser) return this.dashboardUrl;
      if (this.itemOrganization.attributes.preferences.redirect_root_url) return this.itemOrganization.attributes.preferences.redirect_root_url;
      return "#";
    }
  }
}
</script>

<style scoped lang="scss">
@import "application.scss";
.sidebar-logo {
  .navbar-brand {
    width: unset;
  }
  .logo {
    width: 3rem;
    height: 2rem;
    margin-bottom: 2rem;
    object-fit: contain;
  }
}

</style>
